export const formatInstitutionDistribution = (walletAnalysis, getColor) => {
  if (!walletAnalysis || !walletAnalysis.posicao_completa) return {}
  const grupos = walletAnalysis.posicao_completa.grupos
  if (!Array.isArray(grupos) || grupos.length === 0) return {}

  const totalByInstitution = aggregatePlByInstitution(grupos)
  const total = sumValues(totalByInstitution)
  if (!total) return {}

  const result = {}
  const entries = sortEntriesByValueDesc(totalByInstitution)
  entries.forEach(([name, value], index) => {
    result[name] = {
      name,
      value,
      percent: (value / total) * 100,
      color: getColor ? getColor(name, index) : '',
    }
  })
  return result
}

const aggregatePlByInstitution = (grupos) => {
  const acc = {}
  grupos.forEach((group) => {
    const ativos = (group && group.ativos) || []
    ativos.forEach((ativo) => {
      if (!ativo) return
      const name = (ativo.corretora || '').trim()
      if (!name) return
      const pl = Number.isFinite(ativo.pl) ? ativo.pl : 0
      acc[name] = (acc[name] || 0) + pl
    })
  })
  return acc
}

const sumValues = (obj) =>
  Object.values(obj).reduce((sum, value) => sum + value, 0)

const sortEntriesByValueDesc = (obj) =>
  Object.entries(obj).sort((a, b) => b[1] - a[1])
